import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import parseErrorResponse from './errorHandling';

const useLinkPreload = (token) => {
  const { t } = useTranslation();
  const [ processing, setProcessing ] = useState(false);

  const preloadLink = useCallback(async () => {
    try {
      setProcessing(true);
      const response = await axios.get(`/pay-by-link-service/api/v1/preload/${token}`);
      setProcessing(false);
      return response.data;
    } catch (err) {
      setProcessing(false);
      const error = parseErrorResponse(err);
      error.message = t(`error.${error.code}`) || t('error.unexpected');
      throw error;
    }
  }, [token]);

  return { preloadLink, processing };
};

export default useLinkPreload;
